var map = {
	"./loan1.png": 5336,
	"./loan2.png": 9827,
	"./loan3.png": 4618,
	"./loan4.png": 9285,
	"./loan5.png": 9868,
	"./loan6.png": 503,
	"./loan7.png": 7486,
	"./loan8.png": 6873
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 970;